<script>
import { BAlert } from 'bootstrap-vue';
import {
  IconCircleCheck,
  IconCircleXmark,
  IconCircleInfo,
  IconXmark,
} from '@/components/icons/index';

/**
 * Floating toast notifications rendered above modals.
 * Reads from the dedicated "toasts" queue in the alert store module
 * so it does not duplicate the page-level AppAlert messages.
 */
export default {
  name: "AppFloatingToast",

  components: {
    BAlert,
    IconCircleCheck,
    IconCircleXmark,
    IconCircleInfo,
    IconXmark,
  },

  computed: {
    toasts() {
      return this.$store.getters['alert/toasts'];
    },
  },

  methods: {
    dismiss(id) {
      this.$store.commit('alert/dismissToast', id);
    },
  },
};
</script>

<template>
  <div class="floating-toast-wrapper">
    <b-alert
      v-for="toast in toasts"
      :key="toast.id"
      show
      :variant="toast.type"
      class="shadow-1 mb-2"
    >
      <div class="d-flex align-items-start">
        <div>
          <IconCircleCheck v-if="toast.type === 'success'" />
          <IconCircleXmark v-else-if="toast.type === 'danger'" />
          <IconCircleInfo v-else-if="toast.type === 'info'" />
        </div>
        <span class="ms-3 d-block">{{ toast.message }}</span>
        <span role="button" class="d-block ms-auto" @click="dismiss(toast.id)">
          <IconXmark size="12px" />
        </span>
      </div>
    </b-alert>
  </div>
</template>

<style lang="scss" scoped>
.floating-toast-wrapper {
  position: fixed;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: min(480px, calc(100vw - 2rem));
  // Above BootstrapVue modal backdrop (1040) and modal dialog (1050)
  z-index: 2000;
}
</style>
